export default {
	"fgulem": {
		"name": "fgulem",
		"basic": {
			"default": "#1e1e1e",
			"alternative": "#ffffff",
			"fontAlternative": "#02477a",
			"darkMode": "#ffffff"
		},
		"button": {
			"default": "#e20049",
			"font": "#ffffff",
			"darkMode": "#ffffff"
		},
		"soft_basic": {
			"default": "#8E8E8E",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#02477a",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"dark_blue": {
			"default": "#02477a",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/fgulem/logo.png",
		"logocolor": "/static/img/brands/fgulem/logo-color.png",
		"logoencabezado": "/static/img/brands/fgulem/logo-fgulem.png",
		"logodarkmode": "/static/img/brands/fgulem/logo.png",
		"logoSize": "medium",
		"backgroundLeft": "/static/img/brands/fgulem/background.jpg",
		"background": "/static/img/brands/fgulem/encabezado.png",
		"emailContacto": "info@fgulem.es",
		"emailProblemas": "info@fgulem.es",
		"analitycs": "",
		"dominio_produccion": "",
		"portal_publico": "",
		"ownpopup_info": {
			"uso_logo": {
				"titulo": "Autorizo el uso de la imagen de la empresa",
				"texto": "Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en el portal de candidatos/as y en la web pública de empleo de Programa Clave USAL. Aunque autorices ahora, cuando crees ofertas podrás configurar si quieres que se muestren o no, vinculados a esa oferta, los datos de tu empresa."
			}
		},
		"footer": {
			"textos": ["Copyright © ##año## - Fundación General de la Universidad de León y de la Empresa"],
			"links": {
				"Aviso Legal": "https://fgulem.es/aviso.aspx",
				// "Política de Cookies": "",
				"Política de privacidad": "https://fgulem.unileon.es/privacidad.aspx"
			}
		},
		"fonts": {
			"link": "family=Open%20Sans:400,500,700",
			"principal": "'Open Sans', sans-serif",
			"secundaria": "'Open Sans', sans-serif"
		},
		"ownstyles": "/static/img/brands/fgulem/style.css",
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Titulados",
			"empresas": "Empresas"
		},

		"mostrarAdhesion": true,
		"urlPortalTutores": "",

		//PROPUESTA DE PRÁCTICAS
		
		"showPropuestaPracticas": true,
		"requestProgramaPracticas": true,
		"hasProgramaPracticasActivo": true,
		"hasProgramaPracticasInHome": true,
		"requestDatosFirmanteEnPropuesta": true,


		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": false,
		"canDuplicarOferta": true,
		"canDeleteOferta": true,
		"otrasRemuneracionesEnPracticas": true,
		"hasAnyoMaximoPromocion": true,
		"requestDatosFirmanteEnOferta": true,
		"requestDatosTutorEnOferta": true,
		"hideOpcionesCandidatos": true,
		"showMotivoRechazo": true,
		"poblacionesDomain": true,
		"tiempoDedicacionJornada": true,
		"HistoricoOfertas": true,
		"openTitulacionesSelector": true,
		"ocultarEmpresaEnOferta": true,
		"localidadesEnDominios": true,
		"withoutEmpleo" : false,
		"adhesionprogramadirecta" : true,
		"controlProgramaEuropa" : true,
		"controlProgramaEspana" : true,
		"sumaImportesPrograma" : true,

		"camposOferta": {
			"tareas": {
				"showIn": ["Practicas"]
			},
			"otraRemuneracion": {
				"label": "Otros beneficios",
				"showIn": ['Practicas', 'Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": "Beca mensual / Bolsa complementaria",
				"showIn": ['Practicas'],
				"showhelp" : true
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo', 'practicastitulados'],
				"showrequired": true
			},
			"otraFormacion": {
				"label": "Otra formación",
				"showIn": ['Practicas']
			},
			"anyoMaximoPromocion": {
				"label": "Año de promoción límite",
				"showIn": ['Empleo']
			},
			"descripcion": {
				"label": {
					"empleo": "Funciones*",
					"Practicas": "Descripción del puesto*"
				}
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			}
		},

		"camposPracticas": {
			"tareasDesglosadas": true,
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"otraRemuneracion": {
				"label": "Otros beneficios",
				"required": true
			},
			"ayudaEstudio": {
				"label": "Beca mensual",
				"disabledHide": false
			},
			
			"tutorEmpresa": {
				"cargo": true,
				"departamento": true,
				"telefono": true,
				"titulacion": false
			}
		},

		//REGISTRO DE LA EMPRESA
		"requestDireccionContactoEmpresa": true,
		"requestDireccionFullContactoEmpresa": true,
		"requestDireccionFacturacion": false,
		"requestTipoEmpresa": true,
		"requestTipoContacto": true,
		"hideRequestFirmanteRegistro": true,
		"requestPerfilSectorial": true,
		"checkDatosCompletosEmpresa": true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
		},


		//CV DEL CANDIDATO
		"canEditDeLaUniversidad": true,
		"quitarCampoDiscapacidad": true,
		"estanciaenextranjero": true,
		"hasDocumentacionLigadaProcesos": true,
		"quitarCampoNotaAcademicos": true,
		"formacionComplementaria": true,
		"competenciasProfesionales": true,
		"nivelesInformaticos": true,
		"BornActive": true,
		"popupDatosObligatorios": true,
		"hideMinimaRemuneracion" : true,
		"conPlanesAsociadosAlaUni" : true,
		"notaMediaPropia" : false,
		"academicos": {
			"nivelesEstudio": {
				"editable": true
			},
			"ramaTitulacion": {
				"editable": true
			},
			"certificado": {
				"editable": true
			},
			"horas": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"nota": {
				"editable": true
			},


		},



		"personales": {
			"tipoDocumentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": true
			},
			"imagen": {
				"visible": true,
				"editable": true
			},
			"nombre": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido1": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido2": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"movil": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"genero": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"generosentido": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"aceptaNewsletter": {
				"visible": false,
				"editable": false,
				"required": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"password": true,
			"iban": {
				"visible": true,
				"editable": true
			},
			"SWIFT": {
				"visible": true,
				"editable": true,
				"required": false
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"idPaisNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"provinciaNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"lugarNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true
				},
				"2": {
					"visible": true,
					"editable": true
				}
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
			"idTipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idsubtipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idActividadProfesional": {
				"editable": true,
				"validate": 'required'
			},
			"enlace": {
				"editable": true,
				"validate": ''
			},
			"adjunto": {
				"editable": true,
				"validate": ''
			}
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			}
		},

		"interes" : {
			"empleo" :{
				"editable": true,
				"visible": true
			},
		},

		//REGISTRO DE LOS ALUMNOS
		"canRegistroAlumno": ['antiguos','estudiantes','alumnos'],
		"OneLoginForCandidatos": true,
		"hideSAML": true,
		"canBorrarCuenta": true,
		"checkDatosNecesariosEnLogin": true,
		"canRecoveryPass": true,

		//DOCUMENTACIÓN DE EMPRESAS
		"hasDocumentacionPrivadaCV": true,
		"estanciaenextranjero": false,
		"canUploadDocEmpresas": true,
		"literalAnexosFirmados": "Documentos firmados para prácticas asignadas",
		"hideConveniosFirmados": true,
		"haveDocumentosPrograma": true

	},
}


// WEBPACK FOOTER //
// ./src/brands/brands.js